import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";

type TIntercomTarget = {
  asOwner: string;
  asMember: string;
  asDisruptor: string;
};

export default function getIntercomTarget(user: NonNullable<ISelfieQuery["selfie"]>, target: TIntercomTarget) {
  if (user.__typename === "VendorUser") {
    if (user.company && user.company.isDisruptor && target.asDisruptor) {
      return target.asDisruptor;
    } else if (
      (user.role === "COMPANY_OWNER" || (user.company && user.company.usersCanAccessAccountPage)) &&
      target.asOwner
    ) {
      return target.asOwner;
    } else if (user.role === "COMPANY_MEMBER" && target.asMember) {
      return target.asMember;
    }
  }

  return undefined;
}
